import * as React from "react";
import { singleton } from "logic/singleton";
const ScrollPositionContext = React.createContext(void 0);
export default singleton("contexts.enterprise.LogViewScrollPositionContext", () => ScrollPositionContext);
